import PhotoSwipeLightbox from './lib/photoswipe/photoswipe-lightbox.esm';
import PhotoSwipe from './lib/photoswipe/photoswipe.esm.js';


const wbsRoomGallery = ()=> {

    const lightbox = new PhotoSwipeLightbox({
        gallery: '#roomGallery',
        children: 'a',
          pswpModule: PhotoSwipe
    });

    lightbox.init();
};

wbsRoomGallery();